import type { Component } from 'vue'
import {
  ArrowPathIcon as HeroArrowPathIcon,
  ArrowRightIcon as HeroArrowRightIcon,
  ArrowRightOnRectangleIcon as HeroArrowRightOnRectangleIcon,
  BeakerIcon as HeroBeakerIcon,
  ChartBarIcon as HeroChartBarIcon,
  ChatBubbleLeftRightIcon as HeroChatBubbleLeftRightIcon,
  CircleStackIcon as HeroCircleStackIcon,
  ClipboardDocumentListIcon as HeroClipboardDocumentListIcon,
  CodeBracketIcon as HeroCodeBracketIcon,
  FunnelIcon as HeroFunnelIcon,
  GiftIcon as HeroGiftIcon,
  InboxIcon as HeroInboxIcon,
  LinkIcon as HeroLinkIcon,
  PresentationChartLineIcon as HeroPresentationChartLineIcon,
  QuestionMarkCircleIcon as HeroQuestionMarkCircleIcon,
  Squares2X2Icon as HeroSquares2X2Icon,
  TagIcon as HeroTagIcon,
  TrophyIcon as HeroTrophyIcon
} from '@heroicons/vue/24/outline'
/**
 * Default SVG icons for the flow builder
 * These can be overridden by passing custom icons via props
 */

export const EllipsisVerticalIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
    </svg>
  `
}

export const TrashIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
    </svg>
  `
}

export const BoltIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  `
}

export const DocumentDuplicateIcon = {
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
    </svg>
  `
}

const iconComponentMap: Record<string, Component> = {
  'hugeicons:message-question': HeroQuestionMarkCircleIcon,
  'hugeicons:flow-square': HeroSquares2X2Icon,
  'hugeicons:hierarchy-square-08': HeroSquares2X2Icon,
  'hugeicons:award-01': HeroTrophyIcon,
  'hugeicons:inbox': HeroInboxIcon,
  'hugeicons:gift': HeroGiftIcon,
  'hugeicons:message-01': HeroChatBubbleLeftRightIcon,
  'hugeicons:move-right': HeroArrowRightIcon,
  'hugeicons:code': HeroCodeBracketIcon,
  'hugeicons:database': HeroCircleStackIcon,
  'hugeicons:tag-01': HeroTagIcon,
  'hugeicons:form': HeroClipboardDocumentListIcon,
  'hugeicons:webhook': HeroLinkIcon,
  'hugeicons:filter-horizontal': HeroFunnelIcon,
  'hugeicons:logout-04': HeroArrowRightOnRectangleIcon,
  'hugeicons:test-tube-01': HeroBeakerIcon,
  'hugeicons:help-circle': HeroQuestionMarkCircleIcon,
  'hugeicons:presentation-chart-01': HeroPresentationChartLineIcon,
  'hugeicons:copy': DocumentDuplicateIcon,
  'hugeicons:trash': TrashIcon,
  'hugeicons:refresh': HeroArrowPathIcon,
  'hugeicons:message-bubble': HeroChatBubbleLeftRightIcon,
  'hugeicons:chart-bar': HeroChartBarIcon
}

export function resolveFlowIcon(icon: unknown): Component | null {
  if (!icon) return null
  if (typeof icon !== 'string') return icon as Component
  return iconComponentMap[icon] || HeroQuestionMarkCircleIcon
}